function initLivvoltKart(root){
  'use strict';
  if(!root||root.dataset.lvInitialized==='true')return;
  root.dataset.lvInitialized='true';
  const videos = [...root.querySelectorAll('video')];
  videos.forEach(v => {
    v.addEventListener('loadeddata', () => v.classList.add('is-ready'));
    v.addEventListener('play', () => videos.forEach(other => {
      if (other !== v && !other.hasAttribute('data-auto-video')) other.pause();
    }));
  });
  const autoplay = [...root.querySelectorAll('[data-auto-video]')];
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(entries => entries.forEach(({target,isIntersecting}) => {
      if (isIntersecting) { const p = target.play(); if (p) p.catch(() => {}); }
      else target.pause();
    }), {threshold:.15});
    autoplay.forEach(v => observer.observe(v));
  }

  root.querySelectorAll('[data-scroll]').forEach(rail => {
    const controls = rail.nextElementSibling;
    if (!controls || !controls.classList.contains('scroll-controls')) return;
    const prev = controls.querySelector('[data-scroll-prev]');
    const next = controls.querySelector('[data-scroll-next]');
    if (!prev || !next) return;
    const step = () => (rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth*.85) + 18;
    prev.addEventListener('click', () => rail.scrollBy({left:-step(),behavior:'smooth'}));
    next.addEventListener('click', () => rail.scrollBy({left:step(),behavior:'smooth'}));
    const update = () => {
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    rail.addEventListener('scroll',update,{passive:true});
    addEventListener('resize',update,{passive:true});
    update();
  });

  const thumbs = [...root.querySelectorAll('[data-gallery-src]')];
  const stage = root.querySelector('#gallery-stage');
  let galleryIndex = 0;
  const galleryPlayCover=stage?.querySelector('[data-gallery-play]');
  galleryPlayCover?.addEventListener('click',()=>{
    const media=stage.querySelector('video');if(!media)return;
    galleryPlayCover.hidden=true;
    const playback=media.play();
    if(playback)playback.catch(()=>{galleryPlayCover.hidden=false;});
  });
  function showGallery(index) {
    if (!stage || !thumbs.length) return;
    galleryIndex = (index+thumbs.length)%thumbs.length;
    const chosen = thumbs[galleryIndex];
    const old = stage.querySelector('.gallery-main, .gallery-main-video');
    if (old?.tagName === 'VIDEO') old.pause();
    const isVideo = chosen.dataset.gallerySrc.endsWith('.mp4');
    const media = document.createElement(isVideo?'video':'img');
    media.src = chosen.dataset.galleryUrl;
    stage.classList.toggle('is-video',isVideo);
    if(galleryPlayCover)galleryPlayCover.hidden=!isVideo;
    media.className = isVideo ? 'gallery-main-video' : 'gallery-main'+(chosen.dataset.gallerySrc.startsWith('photo-')?' lifestyle':'');
    if (isVideo) { media.controls = true; media.playsInline = true; media.preload = 'metadata'; media.poster=root.dataset.galleryPoster; }
    else media.alt = chosen.dataset.galleryLabel;
    old.replaceWith(media);
    root.querySelector('#gallery-caption').textContent = chosen.dataset.galleryLabel;
    root.querySelector('#gallery-count').textContent = `${galleryIndex+1} / ${thumbs.length}`;
    thumbs.forEach((t,i) => { t.classList.toggle('active',i===galleryIndex); t.setAttribute('aria-pressed',String(i===galleryIndex)); });
    chosen.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
  }
  thumbs.forEach((t,i) => t.addEventListener('click',() => showGallery(i)));
  root.querySelector('[data-gallery-prev]')?.addEventListener('click',() => showGallery(galleryIndex-1));
  root.querySelector('[data-gallery-next]')?.addEventListener('click',() => showGallery(galleryIndex+1));
  if (stage) {
    let startX=0,startY=0;
    stage.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;startY=e.changedTouches[0].clientY;},{passive:true});
    stage.addEventListener('touchend',e=>{
      if(e.target.closest('video,button'))return;
      const dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;
      if(Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy))showGallery(galleryIndex+(dx<0?1:-1));
    },{passive:true});
  }


  root.addEventListener('play',event=>{if(event.target.tagName==='VIDEO')root.querySelectorAll('video').forEach(v=>{if(v!==event.target&&!v.hasAttribute('data-auto-video'))v.pause();});},true);
  // Native Shopify product form, with progressive AJAX enhancement and cart redirect.
  const orderForm=root.querySelector('#lvKbOrderForm');
  const qty=root.querySelector('#product-qty');
  const country=root.querySelector('#ship-country');
  const variantInput=root.querySelector('[data-kb-variant-input]');
  const variantSelect=root.querySelector('[data-kb-variant-select]');
  const addButton=root.querySelector('[data-kb-add-to-cart]');
  const quoteLink=root.querySelector('[data-kb-shipping-quote]');
  const status=root.querySelector('[data-kb-order-status]');
  let variants=[];
  try{variants=JSON.parse(root.querySelector('[data-kb-variants]')?.textContent||'[]');}catch(_){}
  let busy=false;
  const freeCountries=new Set(['US','AU','FR','AE','SA','MY']);
  const selectedVariant=()=>variants.find(v=>String(v.id)===String(variantInput?.value));
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(value/100);
  const quantity=()=>Math.max(Number(qty?.min)||1,Math.floor(Number(qty?.value)||1));
  function ready(v){return root.dataset.ordersEnabled==='true'&&root.dataset.currency==='USD'&&root.dataset.sellingPlanRequired!=='true'&&v?.available===true&&v.price===699900&&v.compare_at_price===899900&&!v.requires_selling_plan;}
  function updateOrder(){
    if(!orderForm||!qty||!addButton)return;
    const v=selectedVariant();
    qty.value=quantity();
    const supported=freeCountries.has(country?.value);
    const validQuantity=qty.checkValidity();
    addButton.disabled=busy||!supported||!ready(v)||!validQuantity;
    addButton.setAttribute('aria-disabled',String(addButton.disabled));
    addButton.hidden=!supported;quoteLink.hidden=supported;
    if(!busy)addButton.textContent='ADD TO CART — '+money((v?.price||0)*quantity());
    const name=country?.selectedOptions[0]?.textContent||'';
    const shipping=root.querySelector('[data-shipping-result]');
    if(shipping)shipping.textContent=supported?'Free shipping to '+name+'.':'Contact us for a shipping quote before ordering.';
    if(!busy&&status)status.textContent=!ready(v)?'Online ordering is temporarily unavailable. Please contact LIVVOLT for assistance.':(!validQuantity?'Please select an available quantity.':'');
    const price=root.querySelector('.product-price strong');
    if(price&&v)price.textContent=money(v.price);
    const financing=root.querySelector('[data-product-financing]');
    if(financing){financing.dataset.unitPrice=String((v?.price||0)*quantity());financing.dispatchEvent(new CustomEvent('livvolt:financing-update',{detail:{amount:(v?.price||0)*quantity()}}));}
  }
  qty?.addEventListener('input',updateOrder);
  country?.addEventListener('change',updateOrder);
  variantSelect?.addEventListener('change',()=>{
    variantInput.value=variantSelect.value;
    const v=selectedVariant();const rule=v?.quantity_rule||{};
    qty.min=rule.min||1;qty.step=rule.increment||1;
    if(rule.max)qty.max=rule.max;else qty.removeAttribute('max');
    qty.value=rule.min||1;updateOrder();
  });
  root.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{qty.stepDown();updateOrder();});
  root.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{qty.stepUp();updateOrder();});
  orderForm?.addEventListener('submit',async event=>{
    event.preventDefault();
    const v=selectedVariant();
    if(busy||!ready(v)||!freeCountries.has(country?.value)||!qty.checkValidity()){updateOrder();return;}
    busy=true;updateOrder();addButton.textContent='ADDING TO CART…';status.textContent='';
    try{
      const response=await fetch(root.dataset.cartAddUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:quantity()}]})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||result.message||'Unable to add this item. Please try again.');
      if(!Array.isArray(result.items)||!result.items.some(item=>String(item.variant_id||item.id)===String(v.id)))throw new Error('Unable to confirm the cart update. Please check your cart before trying again.');
      status.textContent='Added to cart. Opening your cart…';
      window.location.assign(root.dataset.cartUrl);
    }catch(error){
      busy=false;updateOrder();status.textContent=error.message||'Unable to add this item. Please try again.';
    }
  });
  updateOrder();

  // Change only presentation after the unchanged legacy signup handler runs.
  // Event names, tags, hCaptcha, native submit and tracking storage keys are untouched.
  function refreshSignupCopy(){
    root.querySelectorAll('.kb-ok-sm').forEach(el=>{
      const text='✓ YOU’RE ON THE LIST';if(el.textContent!==text)el.textContent=text;
    });
  }
  refreshSignupCopy();
  window.addEventListener('load',refreshSignupCopy,{once:true});
  window.addEventListener('pageshow',refreshSignupCopy);
  const signupObserver=new MutationObserver(refreshSignupCopy);
  const slot=root.querySelector('#kbFinalSignup');
  if(slot)signupObserver.observe(slot,{subtree:true,childList:true});
  setTimeout(()=>signupObserver.disconnect(),10000);

}
document.querySelectorAll("[data-lv-kb-root]").forEach(initLivvoltKart);
document.addEventListener("shopify:section:load",event=>event.target.querySelectorAll("[data-lv-kb-root]").forEach(initLivvoltKart));
